import { Link } from "react-router-dom";
import { mediaUrl } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

export const BrandLogo = ({ className = "" }) => {
  const { settings: s } = useSettings();
  if (s.logo_url) return <img data-testid="brand-logo-image" src={mediaUrl(s.logo_url)} alt={s.site_name || "Chronique.cd"} className={`h-14 sm:h-16 w-auto object-contain ${className}`} />;
  const name = s.site_name || "Chronique.cd";
  const idx = name.lastIndexOf(".");
  return (
    <div className={`font-heading text-4xl sm:text-5xl font-black tracking-tight leading-none ${className}`}>
      {idx > 0 ? <>{name.slice(0, idx)}<span className="text-red-600">{name.slice(idx)}</span></> : name}
    </div>
  );
};

export const SiteHeader = () => {
  const { settings: s } = useSettings();
  const Ad = s.ad_link ? "a" : "div";
  const adProps = s.ad_link ? { href: s.ad_link, target: "_blank", rel: "noreferrer" } : {};
  return (
    <header className="bg-[#111827] text-white">
      <div className="container-site flex flex-col md:flex-row md:items-center justify-between gap-6 py-7">
        <Link to="/" data-testid="brand-logo" className="group">
          <BrandLogo />
          <p className="text-zinc-400 text-sm mt-1.5">{s.tagline || "L'information au cœur de la RDC"}</p>
        </Link>
        <Ad {...adProps} data-testid="header-ad-banner" className="w-full md:w-[540px] h-[80px] relative overflow-hidden block bg-gradient-to-r from-red-700 to-red-600">
          {s.ad_image_url ? (
            <img src={mediaUrl(s.ad_image_url)} alt={s.ad_title || "Publicité"} className="w-full h-full object-cover" />
          ) : (
            <div className="flex items-center justify-between px-6 h-full">
              <div className="absolute inset-y-0 right-0 w-1/3 bg-white/95 skew-x-[-12deg] translate-x-8" />
              <div className="relative z-10">
                <div className="font-heading font-black text-xl uppercase leading-tight">{s.ad_title || "Espace publicitaire"}</div>
                <div className="text-xs tracking-[0.2em] uppercase text-red-100">{s.ad_subtitle || "Votre marque ici"}</div>
              </div>
              <div className="relative z-10 text-right text-[#111827] font-heading font-bold text-xs leading-tight pr-1">540<br />×<br />80</div>
            </div>
          )}
        </Ad>
      </div>
    </header>
  );
};
